import PropTypes from 'prop-types';
import { SearchFormContainer } from 'components/SearchFormAndResults/SearchFormContainer/SearchFormContainer';
import { SearchFormAndResultsProvider } from 'components/SearchFormAndResults/SearchFormAndResultsProvider';
import { SearchResultsWrapper } from 'components/SearchFormAndResults/SearchResultsWrapper/SearchResultsWrapper';

export const SearchFormAndResults = (props) => (
  <SearchFormAndResultsProvider>
    <SearchFormContainer {...props} />
    <SearchResultsWrapper />
  </SearchFormAndResultsProvider>
);

export const SearchFormAndResultsSC = (props) => {
  const { sitecoreData } = props;
  return <SearchFormAndResults {...sitecoreData} />;
};

SearchFormAndResultsSC.propTypes = {
  sitecoreData: PropTypes.object,
};

SearchFormAndResults.propTypes = {
  searchSet: PropTypes.array,
  searchString: PropTypes.string,
  searchOrderBy: PropTypes.arrayOf(PropTypes.object),
  filtersActive: PropTypes.bool,
  sortByActive: PropTypes.bool,
  sortByValue: PropTypes.string,
  tileType: PropTypes.string,
  popularSearches: PropTypes.arrayOf(PropTypes.object),
  errorMessage: PropTypes.string,
  RedirectUrl: PropTypes.string,
};
